// external libraries
import get from "lodash/get";

// local
import { Api, ApiResponse } from "./_base";

// types
import { ISortInfo } from "../types/IPageable";
import { AuthGroup } from "@app/entities/auth";

export function loadCompanies(
  page: number = 0,
  sortInfo?: ISortInfo,
  size: number = 20,
  params: { [key: string]: string | string[] } = {}
): Promise<ApiResponse<any>> {
  const sort = get(sortInfo, "hasSort", false)
    ? `&sort=${sortInfo.sortBy},${sortInfo.isDescending ? "DESC" : "ASC"}`
    : "";
  return Api.execute({
    url: `/api/proxy/ms-profile/v1/companies?page=${page}&size=${size}${sort}`,
    params,
  });
}

export function loadSwitchableCompanies(
  userId: number
): Promise<ApiResponse<any>> {
  return Api.execute({
    url: `/api/companies/${userId}/switchable-companies`,
  });
}

export function updateSwitchableCompanies(
  userId: number,
  companyList: number[]
): Promise<ApiResponse<any>> {
  return Api.execute({
    url: `/api/companies/${userId}/switchable-companies`,
    method: "PUT",
    data: {
      companyList,
    },
  });
}

export function switchCompany(companyId: number): Promise<ApiResponse<any>> {
  return Api.execute({
    url: `/api/companies/switch/${companyId}`,
    method: "POST",
  });
}

export function fetchCompanyGroups(
  companyId: string
): Promise<ApiResponse<any>> {
  return Api.execute({
    url: `/api/companies/${companyId}/groups`,
  });
}

export const updateAuthGroup = (
  data: AuthGroup
): Promise<ApiResponse<AuthGroup>> => {
  return Api.execute({
    url: `/api/proxy/ms-auth/v1/groups`,
    method: "POST",
    data,
  });
};

export function fetchMyCompanyGroups(): Promise<ApiResponse<any>> {
  return Api.execute({
    url: "/api/companies/groups",
  });
}

export function fetchMyCompany(): Promise<ApiResponse<any>> {
  return Api.execute({
    url: `/api/companies/me`,
  });
}
